import { motion, AnimatePresence } from "framer-motion";
import { X, Play } from "lucide-react";
import { CONFIG } from "@/lib/data";

export const ShowreelModal = ({ open, onClose }) => (
  <AnimatePresence>
    {open && (
      <motion.div
        initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
        onClick={onClose}
        className="fixed inset-0 z-[95] grid place-items-center bg-black/90 backdrop-blur-md p-4"
        data-testid="showreel-modal"
      >
        <motion.div
          initial={{ opacity: 0, scale: 0.96 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.96 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          onClick={(e) => e.stopPropagation()}
          className="relative w-full max-w-4xl aspect-video rounded-2xl overflow-hidden glass"
        >
          <button onClick={onClose} data-testid="showreel-close" aria-label="Close"
                  className="absolute top-4 right-4 z-20 grid h-10 w-10 place-items-center rounded-full glass hover:border-[var(--border-hover)]">
            <X size={18} />
          </button>
          {CONFIG.showreelVideo ? (
            <video className="h-full w-full object-cover" poster={CONFIG.heroPoster} controls autoPlay muted loop playsInline>
              <source src={CONFIG.showreelWebm} type="video/webm" />
              <source src={CONFIG.showreelVideo} type="video/mp4" />
            </video>
          ) : (
            <div className="relative h-full w-full">
              <img src={CONFIG.heroPoster} alt="Showreel" className="h-full w-full object-cover opacity-60" />
              <div className="absolute inset-0 grid place-items-center">
                <div className="text-center">
                  <span className="mx-auto mb-4 grid h-16 w-16 place-items-center rounded-full btn-accent animate-pulse-glow">
                    <Play size={26} fill="currentColor" className="ml-1" />
                  </span>
                  <p className="font-display text-xl font-bold">Showreel coming soon</p>
                  <p className="font-mono text-xs text-[var(--text-secondary)] mt-1">Your Sora / Veo cinematic reel will play here.</p>
                </div>
              </div>
            </div>
          )}
        </motion.div>
      </motion.div>
    )}
  </AnimatePresence>
);
